import { Label, Tooltip, UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import { Link } from 'shared/components/InteractiveTypography';
import { useApplicationContext } from 'shared/context/ApplicationContext';
import { ELabels } from 'shared/repositories/commercial-search-offers/entities/offer_extended_properties/OfferExtendedPropertiesSchema';

import styles from './ElectronicTradingLabel.css';

type ElectronicTradingLabelProps = {
  type: ELabels;
};

export const ElectronicTradingLabel: FC<ElectronicTradingLabelProps> = props => {
  const { config } = useApplicationContext();
  const legalDocsUrl = config.getStrict<string>('electronicTrading.legalDocsUrl');
  const textsMap = config.get<Record<string, string>>('sellingTypes.agentLists');
  const labelText = textsMap?.[props.type];

  const isAuctionLabel = props.type === ELabels.TradeRealty;

  if (!labelText) {
    return null;
  }

  const label = (
    <Label background="gray10_100" color="black_100">
      {labelText}
    </Label>
  );

  if (isAuctionLabel) {
    return (
      <Tooltip
        arrow={false}
        placement="bottom"
        theme="white"
        title={
          <div className={styles['content']} data-testid="electronic-trading.tooltip">
            <UIText2>
              Объект реализуется через проведение <br />
              торгов в соответствии с ГК РФ
            </UIText2>
            <UIText2 color="primary_100">
              <Link
                behaviour="hover_primary_to_primary_hover"
                href={legalDocsUrl}
                track={() => {}}
                onClick={(e): void => e.stopPropagation()}
              >
                Справочная информация
              </Link>
            </UIText2>
          </div>
        }
      >
        {label}
      </Tooltip>
    );
  }

  return label;
};
